import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import cn from 'classnames';

import TVIcon from '@material-ui/icons/Tv';
import RadioIcon from '@material-ui/icons/Radio';
import OnlineVideoIcon from '@material-ui/icons/PlayCircleOutline';
import PrintIcon from '@material-ui/icons/Description';
import OnlineDisplayIcon from '@material-ui/icons/Computer';
import StorefrontOutlinedIcon from '@material-ui/icons/StorefrontOutlined';
import AllTelecomIcon from '@material-ui/icons/ViewComfy';
import VideoTvAndOttIcon from '@material-ui/icons/LiveTv';
import VideoTvOnlyIcon from '@material-ui/icons/Tv';
import StorefrontIcon from '@material-ui/icons/Storefront';
import DevicesOutlinedIcon from '@material-ui/icons/DevicesOutlined';
import FingerprintOutlinedIcon from '@material-ui/icons/FingerprintOutlined';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import VideoOttOnlyIcon from '@material-ui/icons/OndemandVideo';
import HomeSecurityIcon from '@material-ui/icons/Security';
import SmartPhone from '@material-ui/icons/Smartphone';
import InternetAndMobileIcon from '@material-ui/icons/Phonelink';
import AppsOutlinedIcon from '@material-ui/icons/AppsOutlined';
import InternetAndTvIcon from '@material-ui/icons/Cast';
import InternetAndVideoIcon from '@material-ui/icons/CastConnected';
import PermIdentityOutlinedIcon from '@material-ui/icons/PermIdentityOutlined';
import DevicesOther from '@material-ui/icons/DevicesOther';
import GeneralMarketIcon from '@material-ui/icons/SelectAll';
import HispanicMarketIcon from '@material-ui/icons/Language';
import GenPopTargetIcon from '@material-ui/icons/Accessibility';
import ElitesTargetIcon from '@material-ui/icons/PermIdentity';
import ProspectsTargetIcon from '@material-ui/icons/RecordVoiceOver';
import AllAdsIcon from '@material-ui/icons/Dashboard';
import ConnectivityIcon from '@material-ui/icons/Wifi';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import PhoneIcon from '@material-ui/icons/Phone';
import SecurityServicesIcon from '@material-ui/icons/Lock';
import OtherCommIcon from '@material-ui/icons/Backup';
import MiscIcon from '@material-ui/icons/Work';
import StoreOutlinedIcon from '@material-ui/icons/StoreOutlined';
import ConnectivityMobileIcon from '@material-ui/icons/TapAndPlay';
import ConnectivitySecurityIcon from '@material-ui/icons/ScreenLockPortrait';
import ConnectivityPhoneIcon from '@material-ui/icons/PhoneInTalk';
import ConnectivityOtherCommIcon from '@material-ui/icons/SettingsSystemDaydream';
import AnyCommIcon from '@material-ui/icons/Devices';
import PhoneVoipMobile from '@material-ui/icons/AddIcCall';
import ConnectivityAll from '@material-ui/icons/PhoneInTalk';
import FootballIcon from '@material-ui/icons/SportsFootball';
import PersonIcon from '@material-ui/icons/Person';
import Restaurant from '@material-ui/icons/Restaurant';
import Fastfood from '@material-ui/icons/Fastfood';
import CasualDining from '@material-ui/icons/EventSeat';
import OfferIcon from '@material-ui/icons/LibraryBooks';
import IPhone from '@material-ui/icons/PhoneIphone';
import USIcon from '@material-ui/icons/ViewComfy';
import UKIcon from '@material-ui/icons/ViewQuilt';
import FRIcon from '@material-ui/icons/ViewColumn';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import JPIcon from '@material-ui/icons/FiberManualRecord';
import AUIcon from '@material-ui/icons/LocalPlaySharp';
import RadioOutlinedIcon from '@material-ui/icons/RadioOutlined';
import PlayCircleOutlineOutlinedIcon from '@material-ui/icons/PlayCircleOutlineOutlined';
import PanoramaOutlinedIcon from '@material-ui/icons/PanoramaOutlined';
import AddToHomeScreenOutlinedIcon from '@material-ui/icons/AddToHomeScreenOutlined';
import LiveTvOutlinedIcon from '@material-ui/icons/LiveTvOutlined';
import CastOutlinedIcon from '@material-ui/icons/CastOutlined';
import CastConnectedOutlinedIcon from '@material-ui/icons/CastConnectedOutlined';
import PlaylistPlayOutlinedIcon from '@material-ui/icons/PlaylistPlayOutlined';
import PlaylistAddOutlinedIcon from '@material-ui/icons/PlaylistAddOutlined';
import SubscriptionsOutlinedIcon from '@material-ui/icons/SubscriptionsOutlined';
import MovieFilterOutlinedIcon from '@material-ui/icons/MovieFilterOutlined';
import ViewModuleOutlinedIcon from '@material-ui/icons/ViewModuleOutlined';
import ImportantDevicesIcon from '@material-ui/icons/ImportantDevices';
import TvOutlinedIcon from '@material-ui/icons/TvOutlined';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SmartphoneOutlinedIcon from '@material-ui/icons/SmartphoneOutlined';
import LanguageOutlinedIcon from '@material-ui/icons/LanguageOutlined';
import WifiOutlinedIcon from '@material-ui/icons/WifiOutlined';
import SettingsCellOutlinedIcon from '@material-ui/icons/SettingsCellOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import MobileFriendlyOutlinedIcon from '@material-ui/icons/MobileFriendlyOutlined';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import StoreIcon from '@material-ui/icons/Store';
import HomeIcon from '@material-ui/icons/Home';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import StarsIcon from '@material-ui/icons/Stars';
import DirectionsCar from '@material-ui/icons/DirectionsCar';
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import { Laptop, Watch, SettingsRemote, Cast, AccessTime, Done } from '@material-ui/icons';

import GenericIcon from '@material-ui/icons/Inbox';
const icons = {
  tv: TVIcon,
  disney_radio: RadioOutlinedIcon,
  social_video: PlayCircleOutlineOutlinedIcon,
  offer: OfferIcon,
  print: PrintIcon,
  radio: RadioIcon,
  online_video: OnlineVideoIcon,
  online_display: OnlineDisplayIcon,
  all_telecom: AllTelecomIcon,
  video_tv_ott: VideoTvAndOttIcon,
  video_tv: VideoTvOnlyIcon,
  video_ott: VideoOttOnlyIcon,
  home_security: HomeSecurityIcon,
  mobile: IPhone,
  internet_mobile: InternetAndMobileIcon,
  internet_tv: InternetAndTvIcon,
  internet_video: InternetAndVideoIcon,
  internet_tv_mobile: DevicesOther,
  hispanic: HispanicMarketIcon,
  general: GeneralMarketIcon,
  market_smb: GeneralMarketIcon,
  market_mm_ent: HispanicMarketIcon,
  elites: ElitesTargetIcon,
  gen_pop: GenPopTargetIcon,
  prospects: ProspectsTargetIcon,
  all_ads: AllAdsIcon,
  connectivity: ConnectivityIcon,
  phone: PhoneIcon,
  security_services: SecurityServicesIcon,
  other_comm: OtherCommIcon,
  misc: MiscIcon,
  connectivity_mobile: ConnectivityMobileIcon,
  connectivity_security: ConnectivitySecurityIcon,
  connectivity_phone: ConnectivityPhoneIcon,
  connectivity_other_comm: ConnectivityOtherCommIcon,
  any_comm: AnyCommIcon,
  phone_voip: PhoneIcon,
  cybersecurity: SecurityServicesIcon,
  managed_svc: OtherCommIcon,
  other_svc: MiscIcon,
  phone_voip_mobile: PhoneVoipMobile,
  connectivity_all: ConnectivityAll,
  connectivity_managed_svc: ConnectivityOtherCommIcon,
  smart_phones: SmartPhone,
  computers: Laptop,
  wearables: Watch,
  connected_home: SettingsRemote,
  all_tech: DevicesOther,
  other_tech: Cast,
  all_plans: SmartPhone,
  post_paid_plans: AccessTime,
  pre_paid_plans: Done,
  superbowl: FootballIcon,
  superbowl_56: FootballIcon,
  superbowl_57: FootballIcon,
  superbowl_58: FootballIcon,
  superbowl_59: FootballIcon,
  superbowl_60: FootballIcon,
  black_consumers: PersonIcon,
  all_restaurants: Restaurant,
  qsr_fast_dining: Fastfood,
  casual_dining: CasualDining,
  sandwich_shops: StorefrontIcon,
  internet_video_mobile_home: AllTelecomIcon,
  internet_video_home: SettingsRemote,
  internet_video_mobile: DevicesOther,
  us: USIcon,
  uk: UKIcon,
  jp: JPIcon,
  fr: FRIcon,
  au: AUIcon,
  social_post: AddToHomeScreenOutlinedIcon,
  ooh: SettingsRemote,
  disney_ooh: PanoramaOutlinedIcon,
  market: ChatBubbleIcon,
  hispanic: ChatBubbleOutlineIcon,
  live_tv: LiveTvOutlinedIcon,
  brand_service_only: CastOutlinedIcon,
  brand_multi_show: CastConnectedOutlinedIcon,
  content_single_show: PlaylistPlayOutlinedIcon,
  content_video_ott: PlaylistAddOutlinedIcon,
  stream_brand: ImportantDevicesIcon,
  stream_content: SubscriptionsOutlinedIcon,
  all_svod: MonetizationOnOutlinedIcon,
  all_streaming: MovieFilterOutlinedIcon,
  disney_all_ads: ViewModuleOutlinedIcon,
  atopic_dermatitis: FingerprintOutlinedIcon,
  adult_sufferers: PermIdentityOutlinedIcon,
  caregivers: PeopleAltOutlinedIcon,
  tv_outlined: TvOutlinedIcon,
  olv: PlayCircleOutlineOutlinedIcon,
  social: ImportantDevicesIcon,
  audio: RadioOutlinedIcon,
  general_market: DashboardIcon,
  hispanic_market: LanguageOutlinedIcon,
  all_wireless_internet: AppsOutlinedIcon,
  postpaid_wireless_internet: DevicesOutlinedIcon,
  total_wireless: MobileFriendlyOutlinedIcon,
  wireless_prepaid: SettingsCellOutlinedIcon,
  wireless_postpaid: SmartphoneOutlinedIcon,
  internet: WifiOutlinedIcon,
  micro: StorefrontOutlinedIcon,
  mid: StoreOutlinedIcon,
  ent: BusinessOutlinedIcon,
  public_sector: StarsIcon,
  all_retail: ShoppingBasketIcon,
  big_box: StoreIcon,
  home_improvement: HomeIcon,
  ecommerce_focused: ShoppingCartIcon,
  department_stores: StorefrontIcon,
  video: TvOutlinedIcon,
  direction_car: DirectionsCar,
  transport: EmojiTransportationIcon
};

const Styled = withStyles(theme => theme.components.generic.Icon(theme));

export default Styled(props => {
  const { type, icon, classes, size, selected } = props;
  const Icon = (icon && icons[icon]) || icons[type] || GenericIcon;

  return selected ? <Icon className={cn(classes[size])} style={{ color: '#ffffff' }} /> : <Icon className={cn(classes[size])} />;
});



// WEBPACK FOOTER //
// ./src/new_components/generic/Icon.js